import { WorkflowError } from '../engine/workflowEngine'
import { findRow } from '../store/localDb.store'
import type { LocalRow } from '../types/localDb.types'

/**
 * D97 (diputuskan 2026-10-21, aturan keras — bukan pengaturan): material kategori Tembakau tidak pernah masuk
 * Purchase Request maupun kedatangan supplier/PO (Catat Kedatangan). Tembakau hanya masuk lewat Penerimaan Tembakau.
 */
export const TOBACCO_CATEGORY_CODE = 'TEMBAKAU'

export const TOBACCO_NOT_VIA_PR_PO = 'Tembakau tidak melalui PR/PO — gunakan Penerimaan Tembakau'

const idOf = (value: unknown) =>
  typeof value === 'object' && value !== null ? String((value as { id?: unknown }).id ?? '') : String(value ?? '')

/** Material (baris `mt_material`) berkategori Tembakau. */
export function isTobaccoMaterialRow(material: LocalRow | undefined) {
  if (!material) return false
  const group = findRow('mt_material_group', idOf(material.category_id))
  return String(group?.code ?? '').toUpperCase() === TOBACCO_CATEGORY_CODE
}

export const isTobaccoMaterialId = (materialId: unknown) =>
  isTobaccoMaterialRow(findRow('mt_material', idOf(materialId)))

/** Tolak bila ada material Tembakau; pesan menyebut kode material agar baris yang salah mudah ditemukan. */
export function assertNoTobacco(materialIds: unknown[]) {
  for (const materialId of materialIds) {
    const material = findRow('mt_material', idOf(materialId))
    if (isTobaccoMaterialRow(material))
      throw new WorkflowError(`${TOBACCO_NOT_VIA_PR_PO} (${material?.code}).`, 'ERR_TOBACCO_NOT_VIA_PR_PO')
  }
}
